<!-- NgbDropdown with checkbox options -->
<div #checkboxMultiSelectDropdownBlock>
	<div
		ngbDropdown
		[autoClose]="'outside'"
		display="dynamic"
		container="body"
		[placement]="dropdownPlacement"
		#dropdownRef="ngbDropdown"
		id="multiSelectDropdown"
	>
		<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
		<button
			type="button"
			class="form-control dropdown-toggle dropdown-toggle-split dropdown-btn-toggle text-truncate"
			ngbDropdownToggle
			data-toggle="dropdown"
			[style.width]="dropdownWidth + 'px'"
			[ngTooltip]="dropdownName !== 'Select' ? dropdownName : ''"
			[popperOptions]="tooltipPopperOptions"
		>
			{{ dropdownName | titlecase }}
		</button>
		<div
			ngbDropdownMenu
			class="multi-select-menu"
		>
			<!-- Dropdown component with translate options -->
			<ng-checkbox-multi-select-menu
				[dropdownData]="dropdownData"
				[dropdownWidth]="dropdownWidth + 100"
				[dropdownRef]="dropdownRef"
				[(ngModel)]="value"
				(ngModelChange)="updateSelected()"
			></ng-checkbox-multi-select-menu>
		</div>
	</div>
</div>
